// This is a part of the Cadcorp SIS source code. 
// Copyright (c) NEC Software Solutions UK Limited 1991-2026 
import { appendParameters } from '../../Core/Utils';
class GeognoSISImage extends ol.source.Image {

    constructor(options) {
        options.loader = (extent, resolution, ratio) => {
            return this.imageLoader(extent, resolution, ratio, options.overlay);
        };
        super(options);
        this.sessionId = options.sessionId;
        this.overlay = options.overlay;
        this.photometricInterpretation = options.photometricInterpretation;

        this.overlay.on('themeChanged', (eventArgs) => {
            this.clear();
            this.changed();
            return true;
        });

    }
    imageLoader(extent, resolution, ratio, overlay) {
        return new Promise((resolve, reject) => {
            const width = extent[2] - extent[0];
            const height = extent[3] - extent[1];
            const imageResolution = resolution / ratio;
            const tileWidth = Math.ceil(width / imageResolution);
            const tileHeight = Math.ceil(height / imageResolution);
            var imageUrl = overlay.getImageUrl();
            var params = {
                'bbox': extent.join(','),
                'uniqueParam': performance.now(),
                'tw': tileWidth,
                'th': tileHeight
            };
            imageUrl = appendParameters(imageUrl, params);
            const img = new Image();
            img.onload = () => {
                resolve(img);
            };
            img.onerror = (err) => {
                reject(err);
            }
            img.src = imageUrl
        });
    }
    clear() {
        this.image = null;
    }

}

export default GeognoSISImage;

